import React, { FC, useState, useEffect } from "react";
import { Link } from "gatsby";
import { User } from "../../../models/user";
import ExpandRow from "../../common/expand/expandRow";
import Loading from "../../loading/loading";
import Api from "../../../services/api";
import { OwnedAlbumDetails } from "../../../models/exports";
import { SUSHISWAP_URL } from "../../../constants";

interface TokenSummaryProps {
  ownedAlbums: OwnedAlbumDetails[];
  loading: boolean;
}

const TokenSummary: FC<TokenSummaryProps> = ({ ownedAlbums, loading }) => {
  const [albumBanners, setAlbumBanners] = useState<string[]>();
  const [bannersLoading, setBannersLoading] = useState<boolean>(true);

  const tokensOwnedPercent = (tokensOwned, tokenSupply) => {
    let percent = (tokensOwned / tokenSupply) * 100;
    if (percent > 1) {
      return percent.toFixed(2);
    } else {
      return percent.toFixed(4);
    }
  };

  // loads in all albumBanner URLs after ownedAlbums is loaded
  useEffect(() => {
    if (!loading) {
      const api = new Api();

      Promise.all(
        ownedAlbums.map((album) => {
          return api.getAlbumBannerUrl(album.name, album.creator.address);
        })
      ).then((allBannerURLs) => {
        setAlbumBanners(allBannerURLs);
        setBannersLoading(false);
      });
    }
  }, [loading]);

  if (loading || bannersLoading) {
    return (
      <div className="flex flex-col mx-auto">
        <div className="mt-16 mx-auto">
          <Loading />
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col w-full pb-48">
      {ownedAlbums?.length > 0 ? (
        <ExpandRow label={"Token summary"} defaultOpen={true}>
          <div className="flex flex-col space-y-8">
            {ownedAlbums.map((album, index) => (
              <div
                className="flex flex-col md:flex-row w-full bg-black"
                style={{ borderRadius: "8px" }}
                key={album.tokenName}
              >
                <div className="flex flex-row flex-grow p-16">
                  <div className="w-48 h-48">
                    <img
                      className="rounded-full object-cover h-full w-full border-2 border-dark-divider"
                      src={albumBanners[index]}
                    />
                  </div>
                  <div className="flex flex-col ml-16">
                    <h2 className="text-dark-light-grey">{`${album.balance.toLocaleString()} $${
                      album.tokenName
                    }`}</h2>
                    <p className="body1 text-dark-white-64">{`${tokensOwnedPercent(
                      album.balance,
                      album.totalSupply
                    )}% of total supply`}</p>
                  </div>
                </div>
                <div className="flex flex-row justify-end md:justify-start pb-16 md:pb-0 pr-16 items-center space-x-24">
                  <Link
                    to={`/album/${album.name}`}
                    className="text-dark-red btn-second"
                  >
                    View album
                  </Link>

                  <a
                    href={`${SUSHISWAP_URL}/swap?outputCurrency=${album.tokenAddress}`}
                    target="_blank"
                    className="text-dark-red btn-second"
                  >
                    Trade
                  </a>
                </div>
              </div>
            ))}
          </div>
        </ExpandRow>
      ) : (
        <div className="flex flex-col text-dark-white-64 space-y-16 fade-in">
          <h2>Token summary</h2>
          <p className="body1">Tokens you own will appear here</p>
        </div>
      )}
    </div>
  );
};

export default TokenSummary;
